import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  employeeStatusConfig,
  PAGINATION_DEFAULT,
} from '../../../utils/constants'
import Button from '../../button'
import DataTable from '../../datatable'
import {
  useGetDepartmentEmployees,
  useRemoveEmployeesFromDepartment,
} from '../../../redux/human-resources/hook/departments'
import AddEmployeeToDepartment from '../../modal/hr-section/departments/add-employee-to-department'
import { departments as departmentEmployeeAPI } from '../../../api/hr/department-management'
import EvaluatePerformance from '../../modal/hr-section/performance/evaluate-performance'
import { useAddSupervisorPerformanceEvaluation } from '../../../redux/human-resources/hook/performance'

const DepartmentOverviewTab = () => {
  useEffect(() => {}, [])

  const {
    mutateAsync: addPerformanceEvaluation,
    isLoading: addPerformanceEvaluationLoading,
  } = useAddSupervisorPerformanceEvaluation()

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })
  const [evaluate, setEvaluate] = useState(false)

  const { id } = useParams()

  const { data: department_employees } = useGetDepartmentEmployees(
    id,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      departmentEmployeeAPI
        .getDepartmentEmployees({
          id,
          limit: 10,
          page: 1,
          statusFilter: -1,
          search: inputValue,
        })
        .then((response) => {
          let data = []

          response?.employees?.data?.forEach((item) => {
            data.push({
              label: `${item.employee_first_name} ${item.employee_last_name} | ${item.employee_mobile}`,
              value: item.employee_id,
              employee_id: item.employee_id,
            })
          })

          resolve(data)
        })
        .catch((err) => {
          resolve([])
        })
    })

  const [showAddEmployeeToDepartment, setShowAddEmployeeToDepartment] =
    useState(false)
  const { mutateAsync: removeFromDepartment } =
    useRemoveEmployeesFromDepartment()

  const tableConfig = {
    headers: ['Date Added', 'Employee Name', 'Email', 'Mobile'],
    keys: ['created', 'employeeName', 'employee_email', 'employee_mobile'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Mobile',
        key: 'employee_mobile',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Remove',
      color: 'red',
      action: (id) => {
        let index = department_employees.data.findIndex((item) => item.id == id)
        if (index != -1) {
          removeFromDepartment({
            departmentemployee_lists:
              department_employees.data[index].id.toString(),
          })
        }
      },
    },
    {
      name: 'Move',
      color: 'red',
      action: (id) => {
        let index = department_employees.data.findIndex((item) => item.id == id)
        if (index != -1) {
          removeFromDepartment({
            departmentemployee_lists:
              department_employees.data[index].id.toString(),
          })
        }
      },
    },
  ]

  const bulkActionConfig = [
    {
      label: 'Remove',
      value: 'active',
      action: (data) => {
        let newData = data.split(',')
        let result = []

        newData.forEach((id) => {
          let index = department_employees.data.findIndex(
            (item) => item.id == id
          )
          if (index != -1) {
            result.push(department_employees.data[index].id)
          }
        })
        removeFromDepartment({ departmentemployee_lists: result.join(',') })
      },
    },
  ]

  return (
    <div className='flex flex-col bg-white rounded'>
      {evaluate ? (
        <EvaluatePerformance
          isOpen={evaluate}
          closeModal={() => setEvaluate(false)}
          title='Evaluate Team Performance'
          loadOptions={loadOptions}
          type={'Department'}
          addPerformanceEvaluation={addPerformanceEvaluation}
          addPerformanceEvaluationLoading={addPerformanceEvaluationLoading}
        />
      ) : null}
      {showAddEmployeeToDepartment ? (
        <AddEmployeeToDepartment
          isOpen={showAddEmployeeToDepartment}
          departmentData={id}
          closeModal={() => setShowAddEmployeeToDepartment(false)}
        />
      ) : null}
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Employee List
        </div>
        <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full'>
          <div className='md:w-fit w-[100%]'>
            <Button
              text='Evaluate Performance'
              type='button'
              theme='primary'
              className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
              textClass={'!text-[11px]'}
              leftIcon={'evaluate'}
              onClick={() => {
                // history.push('/performance/select-option')
                setEvaluate(true)
              }}
            />
          </div>
          <div className='md:w-fit w-[100%]'>
            <Button
              text='Add Employees To Department'
              type='submit'
              leftIcon={'add'}
              className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
              textClass={'!text-[11px]'}
              onClick={() => setShowAddEmployeeToDepartment(true)}
            />
          </div>
        </div>
      </div>
      <hr className='divider mt-2' />
      <DataTable
        data={department_employees}
        tableConfig={tableConfig}
        bulkActionConfig={bulkActionConfig}
        statusConfig={employeeStatusConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        searchData={true}
        filterByStatus={true}
      />
    </div>
  )
}

export default DepartmentOverviewTab
